import NBType from '@netbase/nb-type'

/**
 * @typedef {object} FacetServicePropertySchema
 * @property {string} hierarchyPath
 * @property {number} level
 */
const FacetServicePropertySchema = NBType.object().shape('FacetServicePropertySchema', {
  /* @prop */
  hierarchyPath: NBType.string().nullable(),
  /* @prop */
  level: NBType.number()
  /* END */
})
export default FacetServicePropertySchema
// RESERVE BELOW
